import { Inset, Stack, Text } from '@doordash/design-language'
import { get } from 'lodash'
import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router'
import { Application } from 'src/utilities/application/application'
import * as actions from '../../../actions'
import { VehiclePatchData } from '../../../models/types'
import { getOnboardingConfig } from '../../../utilities/onboardingConfig'
import { sleep } from '../../../utilities/sleep'
import { push, Steps } from '../../../utilities/steps'
import t from './strings'
import VehicleDetailsForm, {
  VehicleDetailsSubmitData,
} from './VehicleDetailsForm'

type Props = {
  uniqueLink: string
  application?: Application
  dasherId?: string
  updateDasherApplicant?: (string, VehicleDetailsSubmitData) => Promise<void>
  createDasherAccount?: (string) => Promise<void>
  loadApplication?: (string) => Promise<void>
  updateVehicle?: (vehicleId: number, data: VehiclePatchData) => Promise<void>
  getApplicationStatus?: (uniqueLink: string) => Promise<void>
}

const hasAdditionalCarData = (data: VehicleDetailsSubmitData) =>
  data.make == null || data.model == null || data.color == null

export const VehicleDetailsStep: React.FC<Props &
  RouteComponentProps> = props => {
  const {
    uniqueLink,
    application,
    dasherId,
    updateDasherApplicant,
    createDasherAccount,
    loadApplication,
    updateVehicle,
    getApplicationStatus,
    history,
  } = props

  const onSubmit = async (data: VehicleDetailsSubmitData) => {
    // Ready payload by removing empty keys
    Object.keys(data).forEach(key => data[key].length === 0 && delete data[key])

    // trackSubmitBackgroundCheck(application)

    await updateDasherApplicant(uniqueLink, data)
    await sleep(500)
    if (typeof dasherId === 'undefined' || dasherId === null) {
      await createDasherAccount(uniqueLink)
      await sleep(500)
    }

    if (hasAdditionalCarData(data)) {
      // Note from J: ideal solution should update the API in updateDasherApplicant to include additional car details info
      const applicationStatus = await getApplicationStatus(uniqueLink)
      const vehicleId = get(applicationStatus, 'data.vehicleId')
      if (vehicleId) {
        const { make, model, color } = data
        await updateVehicle(vehicleId, {
          make,
          model,
          color,
        })
      }
    }

    // update the existing application before next step
    await loadApplication(uniqueLink)

    push(uniqueLink, Steps.BackgroundCheckAwait, history)
  }

  const country = get(application, 'country')
  const requireAdditionalCarInfo = getOnboardingConfig(
    'vehicleDetails',
    'requireAdditionalCarInfo',
    country
  )

  return (
    <Inset>
      <Stack size={Stack.Sizes.XLarge}>
        <Text styles={Text.Styles.PageTitle}>{t.vehicleDetailTitle()}</Text>
      </Stack>
      <VehicleDetailsForm
        onSubmit={onSubmit}
        requireAdditionalCarInfo={Boolean(requireAdditionalCarInfo)}
      />
    </Inset>
  )
}

const mapStateToProps = state => ({
  application: state.application,
  dasherId: state.dasherId,
})

const mapDispatchToProps = {
  updateDasherApplicant: actions.updateDasherApplicant,
  createDasherAccount: actions.createDasherAccount,
  updateVehicle: actions.updateVehicle,
  loadApplication: actions.loadApplication,
  getApplicationStatus: actions.getApplicationStatus,
}

export default withRouter<Props & RouteComponentProps>(
  connect(mapStateToProps, mapDispatchToProps)(VehicleDetailsStep)
)
